import { VStack } from '@fhs-legacy/universal-components';

const CartPageContainer = VStack.withConfig({
  paddingBottom: '$5',
});

export default CartPageContainer;
